<template>
  <div id="forgot-email-password">

    <div class="form-content">
      <div class="form-group">
        <label for="email">{{ $t('email') }}</label>
        <input 
          type="email" 
          name="email"
          id="email"
          :placeholder="$t('email')"
          v-model.trim="email"
          v-validate="'required|email'"
          @keyup.enter="sendEmail"
          @blur="showError.email = true"
          :class="{'danger-border': emailError && showError.email}">
        <p class="error-info">
          <span v-if="errors.has('email') && showError.email">{{ errors.first('email') }}</span>
          <span v-else-if="showError.email">{{ emailErrorMsg }}</span>
        </p>
      </div>

      <div class="form-group" id="sendEmail">
        <label for="verificationCode">{{ $t('yourCode') }}</label>
        <span class="send-email wait" v-if="time > 0">{{ $t('sent') }} {{ time }} s</span>
        <span class="send-email" v-else @click="sendEmail">{{ $t('sendEmail') }}</span>

        <input 
          autocomplete="off" 
          type="text" 
          name="verificationCode"
          id="verificationCode"
          :placeholder="$t('yourCode')"
          v-model.trim="verificationCode"
          v-validate="'required|numeric|digits: 5'"
          @keyup.enter="verifyEmailAndCode"
          @blur="showError.verificationCode = true"
          :class="{'danger-border': verificationCodeError && showError.verificationCode}">
        <p class="error-info">
          <span v-if="errors.has('verificationCode') && showError.verificationCode">{{ errors.first('verificationCode') }}</span>
          <span v-else-if="showError.verificationCode">{{ verificationCodeErrorMsg }}</span>
        </p>
      </div>

      <div class="form-group-bottom">
        <button class="form-submit line-button" @click="verifyEmailAndCode" v-show="!loading">{{ $t('next') }}</button>
        <spinner class="spinner-component" :show="loading"></spinner>
      </div>
    </div>

    <div class="modal fade" id="resetModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button class="close" data-dismiss="modal" aria-label="Close">
              <span>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-close"></use>
                </svg>
              </span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ $t('resetPassword') }}</p>
            <p class="email">{{ email }}</p>
            <p>{{ $t('sendToprompt') }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="form-submit">{{ $t('confirm') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Spinner from '../../../components/Spinner.vue'
  import $ from 'jquery'
  import locales from './lang'

  export default{
    name: 'forgot-email-pwd-view',
    components: {Spinner},
    data: function () {
      return {
        time: 0,
        loading: false,
        email: '',
        sendingEmail: false,
        verificationCode: '',
        emailErrorMsg: '',
        verificationCodeErrorMsg: '',
        networkError: this.$t('networkError'),
        showError: {
          email: false,
          verificationCode: false
        },
        isVerificationCodeExpired: false
      }
    },
    locales,
    computed: {
      emailError() {
        return this.errors.has('email') || !!this.emailErrorMsg
      },
      verificationCodeError() {
        return this.errors.has('verificationCode') || !!this.verificationCodeErrorMsg
      }
    },
    watch: {
      email() {
        this.showError.email = false
        this.emailErrorMsg = ''
      },
      verificationCode() {
        this.showError.verificationCode = false
        this.verificationCodeErrorMsg = ''
      }
    },
    methods: {
      sendEmail: function () {
        if (this.sendingEmail || this.time !== 0 || (this.emailErrorMsg && !this.isVerificationCodeExpired)) return
        this.sendingEmail = true
        this.showError.email = true
        this.$validator.validateAll({email: this.email}).then(success => {
          if (!success) {
            this.sendingEmail = false
            return
          }
          this.$http.post('api/verification/email', {
            email: this.email,
            type: 'password_reset'
          }).then((response) => {
            this.sendingEmail = false
            if (response.data.code === 0) {
              this.time = 60
              this.runTimer()
              $('#resetModal').modal('show')
            } else {
              this.emailErrorMsg = response.data.message
            }
          }, () => {
            this.sendingEmail = false
            this.emailErrorMsg = this.networkError
          })
        })
      },
      verifyEmailAndCode() {
        this.showError.verificationCode = true
        if (this.errors.length > 0) {
          return
        }
        this.$validator.validateAll().then(success => {
          if (!success) {
            return
          }
          this.loading = true
          this.$http.post('api/check-verification-code', {
            email: this.email,
            type: 'email',
            'verification_code': this.verificationCode
          }).then((response) => {
            this.loading = false
            switch (response.data.code) {
              case 0: {
                this.$router.push('reset-password?email=' + this.email + '&reset_token=' + response.data.data.token)
                break
              }
              case 120: {
                this.verificationCodeErrorMsg = response.data.message
                break
              }
              case 181: {
                this.isVerificationCodeExpired = true
              }
              default: {
                this.emailErrorMsg = response.data.message
              }
            }
          }, () => {
            this.loading = false
            this.emailErrorMsg = this.networkError
          })
        })
      },
      runTimer: function () {
        if (this.time > 0) {
          --this.time
          setTimeout(this.runTimer, 1000)
        } else {
          this.isDisabled = false
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/formstyle";
  @import "../../../assets/scss/reset-modal";

  #forgot-email-password {
    max-width: 100%;
  }

  div.form-group {
    input {
      margin-top: .08rem;
      height: .54rem;
      line-height: .54rem;
      border: 1px solid #E0D7E3;
      border-radius: 42px;
      padding: 0 24px;
      font-size: 16px;
      &::placeholder {
        color: #ccc;
      }
    }
  }
  .form-group-bottom .form-submit {
    margin: .16rem 0 0;
    height: 54px;
    line-height: 54px;
    font-size: 18px;
    font-weight: 600;
    background-image: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%);
    border-radius: 42px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 4px;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
      border-radius: 42px;
      filter: blur(4px);
      -webkit-filter: blur(4px);
      -moz-filter: blur(4px);
      -ms-filter: blur(4px);
      -o-filter: blur(4px);
      z-index: -1;
    }
  }

  .form-content {
    width: 100%;
    max-width: 4rem;
    margin: 0 auto;
    #sendEmail {
      .send-email {
        position: absolute;
        right: 16px;
        top: 55px;
        font-size: .16rem;
        color: #416CF8;
        letter-spacing: 0.7px;
        cursor: pointer;
        &.wait {
          color: #BDBDBD;
        }
      }
    }
  }
  .form-group-bottom {
    button {
      margin-bottom: .4rem;
    }
  }

  @media (max-width: 767px) {
    div.form-group {
      input {
        height: 0.49rem;
        line-height: .49rem;
        font-size: 14px;
        padding: 0 16px;
      }
    }
    .error-info {
      margin-top: 0.02rem;
    }
    .form-group-bottom .form-submit {
      margin-top: .24rem;
      height: 49px;
      line-height: 49px;
      font-size: 16px;
    }
    .form-content #sendEmail .send-email {
      top: 43px;
      font-size: .14rem;
    }
  }
  
  .glyphicon-remove-sign {
    cursor: pointer;
  }

  .modal-dialog {
    @include modal-dialog($height: 3.4rem, $phone-height: null, $phone-width: 90%, $pc-width: 4.8rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.7rem) 0 0 -45% !important;
    }
  }

  .modal-content {
    border: 0;
    * {
      padding: 0;
      margin: 0;
      border: 0;
    }
  }
  .modal-body {
    padding-top: .2rem;
    text-align: center;
    p {
      font-size: .16rem;
      color: #333333;
      letter-spacing: 0.71px;
      line-height: .28rem;
      margin-bottom: .08rem;
      &.email {
        color: $base-blue;
      }
    }
  }
  .modal-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    button {
      position: relative;
      bottom: .4rem;
      max-width: 2.4rem;
      margin: 0 auto;
    }
  }
</style>




// WEBPACK FOOTER //
// ForgotEmailPwd.vue?71450a24